<template>
  <div id="app">
    <commonhead :active_menu="5" />
    <div class="user_center_order my_style my_stylenew">
      <div class="content_wrap">
        <div class="user_details">
          <div class="imgbox">
            <img v-if="user_info.avatar" :src="user_info.avatar" alt="个人头像" class="pic_full" />
          </div>
          <div class="user_name">{{user_info.name}}</div>
          <div class="user_items">
            <div class="user_item">
              <div class="item_value">{{user_info.free_course}}</div>
              <div class="item_text">体验卡</div>
            </div>
            <div class="user_item">
              <div class="item_value">{{user_info.coins}}</div>
              <div class="item_text">学贝</div>
              <div class="item_action">
                <router-link class="pay_action" to="/user-center-buy">充值</router-link>
              </div>
            </div>
            <div class="user_item">
              <div class="item_value">0</div>
              <div class="item_text">成长值</div>
              <div class="item_action">
                <router-link class="detail_action" to="/user-point">查看</router-link>
              </div>
            </div>
          </div>
        </div>
        <div class="order_list">
          <div class="top_banner">
            <div class="banner_text">人生最大的挑战是不辜负自己的潜能</div>
          </div>
          <div class="top_menu">
            <Tabs v-model="activeName" @tab-click="handleClick">
              <!-- <TabPane label="全部" name="0"></TabPane> -->
              <TabPane label="即将开始" name="0"></TabPane>
              <TabPane label="已结束" name="1"></TabPane>
            </Tabs>
          </div>
          <div class="nodatabox" v-if="(!courseData||courseData.total==0)&&activeName==1">暂无数据</div>
          <div class="nodatabox" v-if="(!courseData||courseData.total==0)&&activeName==0&&user_info.type==1">暂无数据，赶快联系助教免费体验吧</div>
          <div class="nodatabox" v-if="(!courseData||courseData.total==0)&&activeName==0&&user_info.type&&user_info.type!=1">暂无数据,现在去<router-link class="nodata_action" to="/search-teacher">选课中心</router-link>约课</div>
          <Table
            :data="courseData.list"
            style="width: 100%"
            :header-cell-style="{display:'none'}"
            :cell-style="{'text-align':'center','font-size':'14px',border:'none'}"
            class="mycourse_table"
            v-if="courseData.list&&courseData.list.length>0"
          >
            <!-- <TableColumn prop="date" label="上课时间">
              <template slot-scope="scope">{{getLocalTime(scope.row.start)}}</template>
            </TableColumn>
            <TableColumn prop="teacher.real_name" label="授课老师"></TableColumn>
            
            <TableColumn prop="class_tool" label="上课工具">
              <template
                slot-scope="scope"
              >{{scope.row.class_tool == 1 ? '鲸贝在线教室' : scope.row.class_tool == 2 ? 'QQ':'Skype'}}</template>
            </TableColumn>
            <TableColumn prop="status" label="状态">
              <template slot-scope="scope">{{deal_status(scope.row.status)}}</template>
            </TableColumn>-->
            <TableColumn width="870">
              <template slot-scope="scope">
                <div class="course_box">
                  <div class="top_fix_header"></div>
                  <div
                    class="course_data"
                    @click="$router.push('/user-course-detail?id='+scope.row.id+'&course_id='+scope.row.course.id)"
                  >
                    <div class="course_data_left">
                      <div class="course_time">
                        <span class="icon-time"></span>
                        <span class="course_timetext">{{getFormatTime(scope.row.start)}}</span>
                      </div>
                      <div class="course_detailbox">
                        <div class="course_name"></div>
                        <div class="course_chapter"></div>
                        <div class="course_teacher">{{scope.row.teacher.real_name}}</div>
                      </div>
                    </div>
                    <div class="course_data_right">
                      <!-- 即将开始 -->
                      <div
                        class="course_button course_button_normal"
                        @click.stop="cancelbook(scope.row.course_id)"
                        v-if="activeName==0"
                      ><i class="el-icon-loading" v-if="cancel[scope.row.course_id]"></i>取消预约</div>
                      <div
                        class="course_button course_button_primary"
                        @click.stop="$router.push('/user-course-detail?id='+scope.row.id+'&course_id='+scope.row.course.id)"
                        v-if="activeName==0&&scope.row.status == 1 && Math.round(new Date().getTime()/1000) < scope.row.course.start && scope.row.order.is_paid == 1"
                      >去预习上课</div>
                      <div
                        class="course_button course_button_primary"
                        @click.stop="$router.push('/user-course-detail?id='+scope.row.id+'&course_id='+scope.row.course.id)"
                        v-if="activeName==0 && scope.row.status == 1 && scope.row.status == 1 && scope.row.course.start < Math.round(new Date().getTime()/1000) && Math.round(new Date().getTime()/1000).toString() < scope.row.course.end"
                      >去预习上课</div>
                      <!-- 已结束 -->
                      <div class="course_endaction" v-if="activeName == 1">
                        <div
                          class="course_button course_button_primary course_button_end"
                          v-if="activeName==1"
                          @click.stop="getTeacherResult(scope.row.id)"
                        ><i class="el-icon-loading" v-if="result[scope.row.id]"></i>学习报告</div>
                        <div
                          class="course_button course_button_primary course_button_end"
                          v-if="activeName==1"
                          @click.stop="$router.push('/user-course-detail?id='+scope.row.id+'&course_id='+scope.row.course.id)"
                        >回放和复习</div>
                      </div>
                      <div v-if="activeName == 1">
                        <div
                          class="course_button course_button_ignore course_button_end"
                          v-if="activeName==1"
                          @click.stop="unconfirmcourse(scope.row.course_id)"
                        ><i class="el-icon-loading" v-if="unconfirm[scope.row.course_id]"></i>老师缺席</div>
                        <div
                          class="course_button course_button_ignore course_button_end"
                          v-if="activeName==1"
                          @click.stop="$router.push('/user-course-comment?id='+scope.row.id)"
                        >{{scope.row.status==5?'已评价':'评价'}}</div>
                      </div>
                    </div>
                  </div>
                </div>
                <!-- <Button
                  size="mini"
                  type="danger"
                  @click="$router.push('/user-course-detail?id='+scope.row.id+'&course_id='+scope.row.course.id)"
                >详情</Button>
                <Button
                  size="mini"
                  type="success"
                  @click="checkVideo(scope.row.id,1)"
                  v-if="scope.row.status == 1 && scope.row.course.start < Math.round(new Date().getTime()/1000).toString() && Math.round(new Date().getTime()/1000).toString() < scope.row.course.end"
                >进入课堂</Button>
                <Button
                  size="mini"
                  type="success"
                  @click="enter_now(scope.row.id)"
                  v-if="scope.row.status == 1 && Math.round(new Date().getTime()/1000).toString() < scope.row.course.start && scope.row.order.is_paid == 1"
                >进入课堂</Button>
                <Button
                  size="mini"
                  type="success"
                  @click="checkVideo(scope.row.id,0)"
                  v-if="(scope.row.status == 2) || Math.round(new Date().getTime()/1000).toString() > scope.row.course.end "
                >查看回放</Button>
                <Button
                  size="mini"
                  type="success"
                  @click="confirm(scope.row.course.id)"
                  v-if="Math.round(new Date().getTime()/1000).toString() > (scope.row.course.start + 1500) && scope.row.status == 1"
                >确认完成</Button>
                <Button
                  size="mini"
                  type="warning"
                  @click="$router.push('/user-course-comment?id='+scope.row.id)"
                  v-if="scope.row.status == 2"
                >评价</Button>-->
              </template>
            </TableColumn>
          </Table>
          <!--分页器-->
          <div class="pagination pr" v-if="courseData.total>0">
            <Pagination
              background
              @current-change="getCourse"
              :page-size="10"
              layout="total, prev, pager, next"
              :total="courseData.total"
            >></Pagination>
          </div>
        </div>
      </div>
    </div>
    <!--底部信息-->
    <div class="bottombox">
      <commonbottom />
    </div>
    <!-- 学习报告 -->
    <div class="result_modal" v-show="showresult">
      <div class="modal-content">
        <div class="icon-close" @click="modalclose"></div>
        <!-- <div class="icon-download"></div> -->
        <div class="logo"></div>
        <div class="top">
          <div class="left">
            <div class="student_img">
              <img :src="user_info.avatar" alt="" class="pic_full" v-if="user_info.avatar">
            </div>
            <div class="text">刚刚完成了一节课</div>
          </div>
          <div class="right">
            <span class="square"></span>
            <span class="teacher_name">{{resultData.teacher && resultData.teacher.name}}</span>
          </div>
        </div>
        <div class="middle">
          <div id="teacherresult"></div>
        </div>
        <div class="bottom">
          <div class="comment_top">老师评语</div>
          <div class="comment_text">{{resultData.comment}}</div>
        </div>
      </div>
    </div>
    <!--公共底部-->
    <commonfoot />
    <!--公共底部-->
  </div>
</template>

<script>
import { common } from "../../../common.js";
import commonhead from "../common/common_head.vue";
import commonfoot from "../common/common_foot.vue";
import commonbottom from '../common/common_bottom';
import {
  Table,
  TableColumn,
  Button,
  Pagination,
  Tabs,
  TabPane,
  Message,
} from "element-ui";
export default {
  name: "app",
  components: {
    commonhead,
    commonfoot,
    Table,
    TableColumn,
    Button,
    Pagination,
    Tabs,
    TabPane,
    Message,
    commonbottom
  },
  data: function () {
    return {
      activeName: "0",
      courseData: "",
      user_info: {},
      cancel: {},
      unconfirm: {},
      result: {},
      resultData: {},
      showresult: false
    };
  },
  mounted: function () {
    this.get_info();
    this.getCourse(1, 1);
    // this.getTeacherResult(172);
  },
  methods: {
    getLocalTime(nS) {
      return new Date(parseInt(nS) * 1000)
        .toLocaleString()
        .replace(/:\d{1,2}$/, " ");
    },
    getFormatTime(nS) {
      var dayArr = ["周日", "周一", "周二", "周三", "周四", "周五", "周六"];
      var fixed = function (num) {
        return num < 10 ? "0" + num : num;
      };
      var time = new Date(parseInt(nS) * 1000);
      var month = time.getMonth() + 1,
        date = time.getDate(),
        day = time.getDay(),
        hour = time.getHours(),
        minutes = time.getMinutes();
      return (
        "" +
        fixed(month) +
        "-" +
        fixed(date) +
        "(" +
        dayArr[day] +
        ")" +
        " " +
        fixed(hour) +
        ":" +
        fixed(minutes)
      );
    },
    handleClick(tab) {
      this.activeName = tab.name;
      if (tab.name == 1) {
        this.getCourse(1, 2);
      }
      if (tab.name == 0) {
        this.getCourse(1, 1);
      }
      // if (tab.name == 0) {
      //   this.getCourse(1);
      // }
    },
    getCourse(page, type) {
      //获取课程列表
      let self = this;
      common.requestFun(
        self,
        "get",
        "/student/courses",
        {
          page: page,
          type: type,
        },
        (res) => {
          if (res.data.code == 200) {
            self.courseData = res.data.data;
          }
        }
      );
    },
    deal_status(type) {
      switch (type) {
        case 1:
          return "待上课";
          break;
        case 2:
          return "完成";
          break;
        case 3:
          return "学生已确认";
          break;
        case 4:
          return "教师已确认";
          break;
        case 5:
          return "已评价";
          break;
        case 6:
          return "申请退课中";
          break;
        case 7:
          return "退课成功";
          break;
        case 8:
          return "退课失败";
          break;
      }
    },
    checkVideo(id, type) {
      let self = this;
      common.requestFun(
        self,
        "get",
        type == 0
          ? "student/classroom/record/" + id
          : "student/classroom/" + id,
        {},
        (res) => {
          if (res.data.code == 200) {
            window.open(
              res.data.data.url || res.data.data.recordlist[0].https_playpath,
              "_blank"
            );
          } else {
            if (res.data.msg) {
              self.$message({
                message: res.data.msg,
                type: "error",
                center: true,
              });
            }
          }
        }
      );
    },
    confirm(id) {
      let self = this;
      common.requestFun(
        self,
        "get",
        "student/course/done/confirm",
        {
          course_id: id,
        },
        (res) => {
          if (res.data.code == 200) {
            self.getCourse(1);
            self.$message({
              message: "确认完成",
              type: "success",
              center: true,
            });
          } else {
            if (res.data.msg) {
              self.$message({
                message: res.data.msg,
                type: "error",
                center: true,
              });
            }
          }
        }
      );
    },
    enter_now(id) {
      let self = this;
      common.requestFun(
        self,
        "get",
        "/student/classroom/" + id,
        {},
        (res_1) => {
          if (res_1.data.code == 200) {
            if (res_1.data.data) {
              if (res_1.data.data.url) {
                window.open(res_1.data.data.url, "_blank");
              }
            }
          }
        }
      );
    },
    get_info() {
      let self = this;
      common.requestFun(self, "get", "/student/profile", {}, (res) => {
        if (res.data.code == 200) {
          self.user_info = res.data.data;
        } else {
          if (res.data.msg && res.data.code == 401) {
            self.$message({
              message: "请登录",
              type: "error",
              center: true,
            });
          }
          self.$router.push("./");
        }
      });
    },
    cancelbook(id){
      let self = this;
      if(this.cancel[id]){
        return;
      }
      this.cancel[id] = true;
      common.requestFun(self, "get", "/reservation/cancel", {
        course_id: id
      }, (res) => {
        if(res.data.code == 200){
          self.$message({
              message: "取消预约成功",
              type: "success",
              center: true,
          });
        }else{
          if(res.data.code == 404){
            self.$message({
              message: "预约不存在",
              type: "warning",
              center: true,
            });
          }else{
            self.$message({
              message: "取消预约失败",
              type: "error",
              center: true,
            });
          }
        }
        self.cancel[id] = false;
      });
    },
    unconfirmcourse(id){
      let self = this;
      if(this.unconfirm[id]){
        return;
      }
      this.unconfirm[id] = true;
      common.requestFun(self, "post", "/student/course/unconfirm", {
        course_id: id
      }, (res) => {
        if(res.data.code == 200){
          self.$message({
              message: res.data.msg,
              type: "success",
              center: true,
          });
        }else{
          self.$message({
              message: res.data.msg,
              type: "error",
              center: true,
          });
        }
        self.unconfirm[id] = false;
      });
    },
    modalshow(){
      this.showresult = true
    },
    modalclose(){
      this.showresult = false
    },
    getTeacherResult(id){
      let self = this;
      if(this.result[id]){
        return;
      }
      this.result[id] = true;
      common.requestFun(self, "get", "/student/course/grade/"+id, {}, (res) => {
        if(res.data.code == 200){
          self.modalshow();
          const data = res.data.data||{};
          self.resultData = data;
          var value = [data['attendance']||0,data['pronunciation']||0,data['comprehension']||0,data['fluency']||0,data['creativity']||0]
            var dom = document.getElementById("teacherresult");
            var myChart = self.$echarts.init(dom);
            var option = {
              radar: [
                  {
                      indicator: [
                          { name: '参与度',max: 10 },
                          { name: '发音',max: 10 },
                          { name: '理解力',max: 10 },
                          { name: '流畅度',max: 10 },
                          { name: '创造力',max: 10 }
                      ],
                      center: ['50%','56%'],
                      radius: 130,
                      startAngle: 90,
                      splitNumber: 4,
                      name: {
                          textStyle: {
                              color: '#282828',
                              fontWeight: 500,
                              fontFamily: 'PingFang',
                              lineHeight: 20,
                              fontSize: 18
                          }
                      },
                      splitArea: {
                          areaStyle: {
                              color: ['rgba(149, 208, 250, 1)',
                                  'rgba(149, 208, 250, 0.8)', 
                                  'rgba(149, 208, 250, 0.6)',
                                  'rgba(149, 208, 250, 0.4)'],
                          }
                      },
                      axisLine: {
                          lineStyle: {
                              color: 'rgba(209, 236, 255, 0.4)'
                          }
                      },
                      splitLine: {
                          lineStyle: {
                              color: 'rgba(209, 236, 255, 0.4)'
                          }
                      }
                  }
              ],
              series: [{
                type: 'radar',
                data: [
                  {
                    value: value,
                    lineStyle: {
                      color: 'rgb(214,160,155)'
                    },
                    symbol: 'none'
                  }
                ]
              }]
            }
            myChart.setOption(option, true);
        }else{
          self.$message({
              message: res.data.msg,
              type: "error",
              center: true,
          });
        }
        self.result[id] = false;
      });
    }
  },
};
</script>
<style scoped src="./user_center_my.css"></style>
